import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { messages as messagesEn } from '@locales/website/en';
import { messages as messagesEngineEn } from '@locales/engine/en';



Vue.use(VueI18n)

export const loadedLanguages = ['en'];
export const loadedLanguagesEngine = ['en'];

export const i18n = new VueI18n({
  locale: 'en',
  // fallbackLocale: 'en',
  messages: {
    en: {
      ...messagesEn,
      ...messagesEngineEn,
    }
  },
})

function setI18nLanguage(lang) {

  i18n.locale = lang
  return lang
}

export function loadI18nLanguageAsync(lang) {


  if (loadedLanguages.includes(lang)) {

    return Promise.resolve(setI18nLanguage(lang))
  }

  switch (lang) {
    case 'ae':
      return import(/* webpackChunkName: "lang-[request]" */ `@locales/website/en`).then(
        data => {
          i18n.mergeLocaleMessage(lang, data.messages)
          loadedLanguages.push(lang)

          return Promise.resolve(setI18nLanguage(lang))
        }
      )
    case 'br':
      return import(/* webpackChunkName: "lang-[request]" */ `@locales/website/br`).then(
        data => {
          i18n.mergeLocaleMessage(lang, data.messages)
          loadedLanguages.push(lang)

          return Promise.resolve(setI18nLanguage(lang))
        }
      )
    case 'cn':
      return import(/* webpackChunkName: "lang-[request]" */ `@locales/website/cn`).then(
        data => {
          i18n.mergeLocaleMessage(lang, data.messages)
          loadedLanguages.push(lang)

          return Promise.resolve(setI18nLanguage(lang))
        }
      )
    case 'da':
      return import(/* webpackChunkName: "lang-[request]" */ `@locales/website/da`).then(
        data => {
          i18n.mergeLocaleMessage(lang, data.messages)
          loadedLanguages.push(lang)

          return Promise.resolve(setI18nLanguage(lang))
        }
      )
    case 'de':
      return import(/* webpackChunkName: "lang-[request]" */ `@locales/website/de`).then(
        data => {
          i18n.mergeLocaleMessage(lang, data.messages)
          loadedLanguages.push(lang)

          return Promise.resolve(setI18nLanguage(lang))
        }
      )
    case 'en':
      return import(/* webpackChunkName: "lang-[request]" */ `@locales/website/en`).then(
        data => {
          i18n.mergeLocaleMessage(lang, data.messages)
          loadedLanguages.push(lang)

          return Promise.resolve(setI18nLanguage(lang))
        }
      )
    case 'es':
      return import(/* webpackChunkName: "lang-[request]" */ `@locales/website/es`).then(
        data => {
          i18n.mergeLocaleMessage(lang, data.messages)
          loadedLanguages.push(lang)

          return Promise.resolve(setI18nLanguage(lang))
        }
      )
    case 'fr':
      return import(/* webpackChunkName: "lang-[request]" */ `@locales/website/fr`).then(
        data => {
          i18n.mergeLocaleMessage(lang, data.messages)
          loadedLanguages.push(lang)

          return Promise.resolve(setI18nLanguage(lang))
        }
      )
    case 'id':
      return import(/* webpackChunkName: "lang-[request]" */ `@locales/website/id`).then(
        data => {
          i18n.mergeLocaleMessage(lang, data.messages)
          loadedLanguages.push(lang)

          return Promise.resolve(setI18nLanguage(lang))
        }
      )
    case 'in':
      return import(/* webpackChunkName: "lang-[request]" */ `@locales/website/in`).then(
        data => {
          i18n.mergeLocaleMessage(lang, data.messages)
          loadedLanguages.push(lang)

          return Promise.resolve(setI18nLanguage(lang))
        }
      )
    case 'jp':
      return import(/* webpackChunkName: "lang-[request]" */ `@locales/website/jp`).then(
        data => {
          i18n.mergeLocaleMessage(lang, data.messages)
          loadedLanguages.push(lang)

          return Promise.resolve(setI18nLanguage(lang))
        }
      )
    case 'kh':
      return import(/* webpackChunkName: "lang-[request]" */ `@locales/website/kh`).then(
        data => {
          i18n.mergeLocaleMessage(lang, data.messages)
          loadedLanguages.push(lang)

          return Promise.resolve(setI18nLanguage(lang))
        }
      )
    case 'ko':
      return import(/* webpackChunkName: "lang-[request]" */ `@locales/website/ko`).then(
        data => {
          i18n.mergeLocaleMessage(lang, data.messages)
          loadedLanguages.push(lang)

          return Promise.resolve(setI18nLanguage(lang))
        }
      )
    case 'la':
      return import(/* webpackChunkName: "lang-[request]" */ `@locales/website/la`).then(
        data => {
          i18n.mergeLocaleMessage(lang, data.messages)
          loadedLanguages.push(lang)

          return Promise.resolve(setI18nLanguage(lang))
        }
      )
    case 'mm':
      return import(/* webpackChunkName: "lang-[request]" */ `@locales/website/mm`).then(
        data => {
          i18n.mergeLocaleMessage(lang, data.messages)
          loadedLanguages.push(lang)

          return Promise.resolve(setI18nLanguage(lang))
        }
      )
    case 'mn':
      return import(/* webpackChunkName: "lang-[request]" */ `@locales/website/mn`).then(
        data => {
          i18n.mergeLocaleMessage(lang, data.messages)
          loadedLanguages.push(lang)

          return Promise.resolve(setI18nLanguage(lang))
        }
      )
    case 'my':
      return import(/* webpackChunkName: "lang-[request]" */ `@locales/website/my`).then(
        data => {
          i18n.mergeLocaleMessage(lang, data.messages)
          loadedLanguages.push(lang)

          return Promise.resolve(setI18nLanguage(lang))
        }
      )
    case 'pt':
      return import(/* webpackChunkName: "lang-[request]" */ `@locales/website/pt`).then(
        data => {
          i18n.mergeLocaleMessage(lang, data.messages)
          loadedLanguages.push(lang)

          return Promise.resolve(setI18nLanguage(lang))
        }
      )
    case 'ru':
      return import(/* webpackChunkName: "lang-[request]" */ `@locales/website/ru`).then(
        data => {
          i18n.mergeLocaleMessage(lang, data.messages)
          loadedLanguages.push(lang)

          return Promise.resolve(setI18nLanguage(lang))
        }
      )
    case 'sw':
      return import(/* webpackChunkName: "lang-[request]" */ `@locales/website/sw`).then(
        data => {
          i18n.mergeLocaleMessage(lang, data.messages)
          loadedLanguages.push(lang)

          return Promise.resolve(setI18nLanguage(lang))
        }
      )
    case 'th':
      return import(/* webpackChunkName: "lang-[request]" */ `@locales/website/th`).then(
        data => {
          i18n.mergeLocaleMessage(lang, data.messages)
          loadedLanguages.push(lang)

          return Promise.resolve(setI18nLanguage(lang))
        }
      )
    case 'tw':
      return import(/* webpackChunkName: "lang-[request]" */ `@locales/website/tw`).then(
        data => {
          i18n.mergeLocaleMessage(lang, data.messages)
          loadedLanguages.push(lang)

          return Promise.resolve(setI18nLanguage(lang))
        }
      )
    case 'vn':
      return import(/* webpackChunkName: "lang-[request]" */ `@locales/website/vn`).then(
        data => {
          i18n.mergeLocaleMessage(lang, data.messages)
          loadedLanguages.push(lang)

          return Promise.resolve(setI18nLanguage(lang))
        }
      )
    case 'it':
      return import(/* webpackChunkName: "lang-[request]" */ `@locales/website/it`).then(
        data => {
          i18n.mergeLocaleMessage(lang, data.messages)
          loadedLanguages.push(lang)

          return Promise.resolve(setI18nLanguage(lang))
        }
      )
    case 'pl':
      return import(/* webpackChunkName: "lang-[request]" */ `@locales/website/pl`).then(
        data => {
          i18n.mergeLocaleMessage(lang, data.messages)
          loadedLanguages.push(lang)

          return Promise.resolve(setI18nLanguage(lang))
        }
      )
    case 'fi':
      return import(/* webpackChunkName: "lang-[request]" */ `@locales/website/fi`).then(
        data => {
          i18n.mergeLocaleMessage(lang, data.messages)
          loadedLanguages.push(lang)

          return Promise.resolve(setI18nLanguage(lang))
        }
      )
    case 'he':
      return import(/* webpackChunkName: "lang-[request]" */ `@locales/website/he`).then(
        data => {
          i18n.mergeLocaleMessage(lang, data.messages)
          loadedLanguages.push(lang)

          return Promise.resolve(setI18nLanguage(lang))
        }
      )
    default:
      return Promise.resolve(setI18nLanguage(lang))
  }

}

export function loadI18nLanguageEngineAsync(lang) {


  if (loadedLanguagesEngine.includes(lang)) {

    return Promise.resolve(lang);
  }

  switch (lang) {
    case 'en':
      return import(/* webpackChunkName: "lang-engine-[request]" */ `@locales/engine/en`).then(
        data => {
          i18n.mergeLocaleMessage(lang, data.messages)
          loadedLanguagesEngine.push(lang)

          return Promise.resolve(lang);
        }
      )
    case 'id':
      return import(/* webpackChunkName: "lang-engine-[request]" */ `@locales/engine/id`).then(
        data => {
          i18n.mergeLocaleMessage(lang, data.messages)
          loadedLanguagesEngine.push(lang)

          return Promise.resolve(lang);
        }
      )
    case 'th':
      return import(/* webpackChunkName: "lang-engine-[request]" */ `@locales/engine/th`).then(
        data => {
          i18n.mergeLocaleMessage(lang, data.messages)
          loadedLanguagesEngine.push(lang)

          return Promise.resolve(lang);
        }
      )
    default:
      return Promise.resolve(lang);
  }
}

export default i18n;